import React from 'react';
import { motion } from 'framer-motion';

const SectionBadge = ({ icon: Icon, text }) => {
    return (
        <motion.div
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-blue-100 shadow-sm text-blue-600 text-sm 3xl:text-base 4xl:text-lg 5xl:text-xl font-bold uppercase tracking-wider mb-6"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4 }}
        >
            {Icon && (
                <motion.div
                    animate={{ rotate: 360 }}
                    transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
                >
                    <Icon className="w-4 h-4 3xl:w-5 3xl:h-5 4xl:w-6 4xl:h-6" />
                </motion.div>
            )}
            <span>{text}</span>
        </motion.div>
    );
};

export default SectionBadge;
